export const DELETE_SCHEDULE_TIME_SLOT = "DELETE_SCHEDULE_TIME_SLOT"
export const DELETE_SCHEDULE_TIME_SLOT_FAIL = "DELETE_SCHEDULE_TIME_SLOT_FAIL"
export const DELETE_SCHEDULE_TIME_SLOT_SUCCESS = "DELETE_SCHEDULE_TIME_SLOT_SUCCESS"
export const DELETE_SCHEDULE_TIME_SLOT_RESET = "DELETE_SCHEDULE_TIME_SLOT_RESET"

export const deleteScheduleTimeSlot = (params) => {
    return { type: DELETE_SCHEDULE_TIME_SLOT, params }
}
export const deleteScheduleTimeSlotFail = (response) => {
    return { type: DELETE_SCHEDULE_TIME_SLOT_FAIL, response }
}
export const deleteScheduleTimeSlotSuccess = (response) => {
    return { type: DELETE_SCHEDULE_TIME_SLOT_SUCCESS, response }
}
export const deleteScheduleTimeSlotReset = () => {
    return { type: DELETE_SCHEDULE_TIME_SLOT_RESET }
}